import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { constant } from "common/constant";
import { getApi, postApi } from "common/services/api"; 
import { API_PATHS } from "common/services/apiPaths";
import { toast } from "react-toastify";

export const fetchRecruitmentData = createAsyncThunk(
  "recruitment/fetchRecruitmentData",
  async (_, { rejectWithValue }) => {
    try {
      const result = await getApi(API_PATHS.RECRUITMENT_PROFILES);
      const userResult = await getApi(API_PATHS.USER);

      if (result.data.length > 0) {
        const updatedData = result.data.map((res) => ({
          ...res,
          hiringManager: userResult.data.user.find((data) => data._id === res.hiringManager)?.username || constant.notAllowed,
          assignedRecruiter: userResult.data.user.find((data) => data._id === res.assignedRecruiter)?.username || constant.notAllowed,
          department: res.department?.name || constant.notAllowed,
        }));

        return updatedData;
      }
      return [];
    } catch (error) {
      return rejectWithValue(constant.somethingWentWrong);
    }
  }
);

export const addRecruitmentProfile = createAsyncThunk(
    "recruitment/addRecruitmentProfile",
    async ({ values, resetForm, navigate }, { rejectWithValue, dispatch }) => {
      try {
        const response = await postApi(API_PATHS.POST_RECRUITMENT_PROFILES, values);
  
        if (response.status === 201) {
          resetForm();
          toast.success(constant.jobOpeningCreatedSuccess);
          dispatch(fetchRecruitmentData()); 
          navigate("/recruit/jobProfile");
          return response.data;
        } else {
          toast.error(constant.somethingWentWrong);
          return rejectWithValue(constant.failedToAddProfile);
        }
      } catch (error) {
        toast.error(constant.somethingWentWrong);
        return rejectWithValue(error.message || constant.apiReqFailed);
      }
    }
  );
  

const recruitmentSlice = createSlice({
  name: "recruitment",
  initialState: {
    data: [],
    loading: false,
    error: null,
    addLoading: false, 
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRecruitmentData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRecruitmentData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchRecruitmentData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(addRecruitmentProfile.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(addRecruitmentProfile.fulfilled, (state) => {
        state.addLoading = false;
      })
      .addCase(addRecruitmentProfile.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
      });
  },
});

export default recruitmentSlice.reducer;
